import { DateTime } from "luxon";

export const localTimeDate = () => {
  return DateTime.local().setZone("Europe/Amsterdam");
};

export const secondsTimeStamp = () => {
  return Math.floor(DateTime.local().setZone("Europe/Amsterdam").toSeconds());
};

export const fromIso = (date: string) => {
  return DateTime.fromISO(date).setZone("Europe/Amsterdam");
};

export const fromSeconds = (seconds: number) => {
  return DateTime.fromSeconds(seconds).setZone("Europe/Amsterdam");
};

export const timeNowSecond = () => {
  return DateTime.local().setZone("Europe/Amsterdam").toSeconds();
};

export const fromIsoToseconds = (date: string) => {
  return DateTime.fromISO(date).setZone("Europe/Amsterdam").toSeconds();
};

export const toIsoDate = (seconds: number) => {
  return (
    DateTime.fromSeconds(seconds)
      .setZone("Europe/Amsterdam")
      .toFormat("yyyy-MM-dd") +
    `T${DateTime.fromSeconds(seconds)
      .setZone("Europe/Amsterdam")
      .toFormat("HH:mm")}`
  );
};

export const toIsoWithoutTime = (seconds: number) => {
  return DateTime.fromSeconds(seconds)
    .setZone("Europe/Amsterdam")
    .toFormat("yyyy-MM-dd");
};

export const DateShort = (date: DateTime) => {
  return date.setZone("Europe/Amsterdam").toLocaleString(DateTime.DATE_SHORT);
};

export const DateShortTime = (date: DateTime) => {
  return date
    .setZone("Europe/Amsterdam")
    .toLocaleString(DateTime.DATETIME_SHORT);
};

export const dateHuge = (date: DateTime) => {
  return date.setZone("Europe/Amsterdam").toLocaleString(DateTime.DATE_HUGE);
};

export const thisWeek = (date: DateTime) => {
  return date.startOf("week").setZone("Europe/Amsterdam");
};
